import React from 'react';
import {Layout} from 'antd';


const {Content, Footer} = Layout;

interface SuperProps {
    children: React.ComponentType

}

const Super: React.FC<SuperProps> = (
    {children: WrappedChildren}) => {
    console.log('a')
    const test = false
    return (
        <>
            {test && <WrappedChildren/>}
            <p>a</p>
        </>
    )
}

const Dev_ = () => {
    console.log('b')

    return (
        <p>b</p>
    )
}

const Dev: React.FC = () => {
    return (
        <Super children={Dev_}/>
    )
}

export default Dev;